import React from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";

import Layout from "./components/Layout/Layout";

import "@fontsource-variable/figtree";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import Register from "./components/Register/Register";
import RegisterLicenceValidation from "./components/RegisterLicenceValidation/RegisterLicenceValidation";
import RegisterSelect from "./components/RegisterSelect/RegisterSelect";
import RegisterValidation from "./components/RegisterValidation/RegisterValidation";
import BoardList from "./components/BoardList/BoardList";
import Rules from "./components/Rules/Rules";
import ContactUs from "./components/ContactUs/ContactUs";
import Live from "./components/Live/Live";
import LiveFind from "./components/Live/LiveFind";
import BoardRegistrations from "./components/Admin/BoardRegistrations/BoardRegistrations";
import BoardOverlaps from "./components/Admin/BoardOverlaps/BoardOverlaps";
import Registrations from "./components/Admin/Registrations/Registrations";
import AdminBoards from "./components/Admin/Boards/AdminBoards";
import AdminBoardDefinitions from "./components/Admin/BoardDefinitions/AdminBoardDefinitions";
import AdminMatchs from "./components/Admin/AdminMatchs/AdminMatchs";
import AdminTournament from "./components/Admin/Tournament/AdminTournament";
import RegistrationList from "./components/Admin/RegistrationList/RegistrationList";
import AdminRights from "./components/Admin/AdminRights/AdminRights";
import TablesManagement from "./components/Admin/TablesManagement/TablesManagement";
import TablesOccupancy from "./components/Admin/TablesOccupancy/TablesOccupancy";
import AdminDocsPage from "./components/Admin/Docs/AdminDocsPage";
import PlayerDuplicatesAudit from "./components/Admin/PlayerDuplicatesAudit/PlayerDuplicatesAudit";
import BoardNbParticipantsAudit from "./components/Admin/BoardNbParticipantsAudit/BoardNbParticipantsAudit";
import AdminWaitlist from "./components/Admin/Waitlist/AdminWaitlist";
import Home from "./components/Home/Home";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import TournamentsManagement from "./components/Admin/TournamentsManagement/TournamentsManagement";
import Login from "./components/Login/Login";
import Signup from "./components/Signup/Signup";
import RegisterThanks from "./components/RegisterThanks/RegisterThanks";
import Checkin from "./components/Admin/Checkin/Checkin";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import ConfirmResetPassword from "./components/ConfirmResetPassword/ConfirmResetPassword";
import StatsPage from "./features/stats/components/StatsPage";
import MatchDetail from "./components/MatchDetail/MatchDetail";
import InscritsPage from "./components/Inscrits/InscritsPage";
import Resultats from "./components/Resultats/Resultats";

import "./pdfConfig";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          element: <ProtectedRoute />,
          children: [
            { path: "/inscrits", element: <InscritsPage /> },
            { path: "/register", element: <Register /> },
            {
              path: "/pre-registration",
              element: <Register mode="preRegistration" />,
            },
            {
              path: "/register/licence-validation",
              element: <RegisterLicenceValidation />,
            },
            { path: "/register/select", element: <RegisterSelect /> },
            { path: "/register/validation", element: <RegisterValidation /> },
            { path: "/register/thanks", element: <RegisterThanks /> },
          ],
        },
        {
          element: <AdminRoute />,
          children: [
            {
              path: "/admin/board-registrations",
              element: <BoardRegistrations />,
            },
            {
              path: "/admin/board-overlaps",
              element: <BoardOverlaps />,
            },
            { path: "/admin/registrations", element: <Registrations /> },
            { path: "/admin/registration-list", element: <RegistrationList /> },
            { path: "/admin/boards-managment", element: <AdminBoards /> },
            {
              path: "/admin/boards-definitions",
              element: <AdminBoardDefinitions />,
            },
            {
              path: "/admin/tournament-managment",
              element: <AdminTournament />,
            },
            {
              path: "/admin/tournaments-management",
              element: <TournamentsManagement />,
            },
            { path: "/admin/matchs", element: <AdminMatchs /> },
            { path: "/admin/checkin", element: <Checkin /> },
            {
              path: "/admin/tables-occupancy",
              element: <TablesOccupancy />,
            },
            { path: "/admin/stats", element: <StatsPage /> },
            { path: "/admin/admin-rights", element: <AdminRights /> },
            {
              path: "/admin/tables-management",
              element: <TablesManagement />,
            },
            { path: "/admin/docs", element: <AdminDocsPage /> },
            {
              path: "/admin/player-duplicates-audit",
              element: <PlayerDuplicatesAudit />,
            },
            {
              path: "/admin/board-nb-participants-audit",
              element: <BoardNbParticipantsAudit />,
            },
            { path: "/admin/waitlist", element: <AdminWaitlist /> },
          ],
        },
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/boards",
          element: <BoardList />,
        },
        { path: "/rules", element: <Rules /> },
        { path: "/resultats", element: <Resultats /> },
        { path: "/contactus", element: <ContactUs /> },
        { path: "/live", element: <Live /> },
        { path: "/live-find", element: <LiveFind /> },
        {
          path: "/live-player",
          element: <Navigate to="/live-find" replace />,
        },
        { path: "/login", element: <Login /> },
        { path: "/signup", element: <Signup /> },
        { path: "/reset-password", element: <ResetPassword /> },
        { path: "/confirm-reset-password", element: <ConfirmResetPassword /> },
        { path: "/match/:matchId", element: <MatchDetail /> },
        { path: "*", element: <Home /> },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
